import i18n from "i18next";
import moment from "moment";
import { LoadBar } from "../components/ui";
import { isEmpty } from "@fe-util/common";

import CryptoJS from "crypto-js";
export const renderJsonToHTML = (json) => {
  return { __html: json };
};
//export const appNoKey = "appNo";
// 获取当前是中文还是英文
export function getCurrentLang() {
  return i18n.language;
  
  const curWwwPath = window.document.location.href;
  var lang;
  if (curWwwPath.indexOf("/ch/") !== -1 || curWwwPath.indexOf("/CH/") !== -1) {
    // 繁体
    lang = "ch";
  } else if (
    curWwwPath.indexOf("/zh/") !== -1 ||
    curWwwPath.indexOf("/ZH/") !== -1
  ) {
    // 簡體
    lang = "zh";
  } else if (
    curWwwPath.indexOf("/en/") !== -1 ||
    curWwwPath.indexOf("/EN/") !== -1
  ) {
    lang = "en";
  } else {
    // 默认中文
    lang = "ch";
  }
  return lang;
}

//切换中英文
export function switchLanguage(url) {
  console.log(url);
  // 使用正则表达式匹配 /en/ 或 /ch/ 并进行互换
  let urlTemp = url.replace(/\/(en|ch)\//gi, function (match, lang) {
    return "/" + (lang.toLowerCase() === "en" ? "ch" : "en") + "/";
  });
  return urlTemp;
  // return url.replace(urlTemp);
}
/*--防抖--*/
export const debounce = (callback, delay = 500) => {
  let timer = null;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => callback(...args), delay);
  };
};
//校验-FormInput的val只能输入数字
export const formatNum = (str) => {
  // console.log("forInput num:", str);
  let result = str.replace(/\D/g, "");
  // console.log("forInput result:", result);
  return result;
};
//校验-FormInput的val把小写转成大写
export const formatUpperCase = (str) => {
  console.log("forInput num:", str);
  // let result = str.replace(/\D/g, "");
  let result = str.replace(/[a-z]/g, function (char) {
    return String.fromCharCode(char.charCodeAt(0) - 32);
  });
  console.log("forInput result:", result);
  return result;
};

// 日期转换成后端需要的格式
export function formatDate(inputDateString) {
  const date = moment(inputDateString, "DD/MM/YYYY", true); // 解析日期字符串
  let formattedDate = "";
  if (date.isValid()) {
    // 确保日期字符串有效
    formattedDate = date.format("YYYY-MM-DDTHH:mm:ss.sss"); // 格式化日期为所需形式
    // console.log("inputValue:", inputDateString);
    // console.log("formattedDate", formattedDate); // 2023-12-29T11:15:40.733
  } else {
    console.log("无效的日期字符串");
  }
  return formattedDate;
}

// 获取finalPremium
export const computefinalPremium = (originPremium, firstYearDiscount) => {
  return Number(originPremium * 0.01 * (100 - firstYearDiscount)).toFixed(2);
};
// 根据年龄计算出生日期
export const getBirthDate = (age) => {
  if (age === undefined || age === null || age === "") return false;
  const currentYear = new Date().getFullYear();
  const birthYear = currentYear - age;
  const birthDate = new Date(birthYear, 0, 1); // 注意：月份是从0开始的，所以1月是0
  return birthDate;
};
// 根据出生日期计算年龄
export const calculateAge = (dob) => {
  // 确保输入是合法的日期格式
  let regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  if (!regex.test(dob)) {
    return 1;
  }

  // const [, month, day, year] = dob.match(regex);
  // const birthDate = new Date(`${year}-${month}-${day}`);
  // const currentDate = new Date();
  // const differenceInMilliseconds = currentDate - birthDate;
  // const differenceInYears = differenceInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // 考虑闰年
  // return Math.floor(differenceInYears); // 取整数部分作为年龄
  // debugger;
  const dateParts = dob.split("/");
  const dobFormat = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // 注意月份是从0开始的，所以需要减1

  const today = new Date();
  const todayYear = today.getFullYear();
  let age = todayYear - dobFormat.getFullYear();

  // 检查是否过了今年的生日
  if (
    dobFormat.getMonth() < today.getMonth() ||
    (dobFormat.getMonth() === today.getMonth() &&
      dobFormat.getDate() <= today.getDate())
  ) {
    return age;
  }
  age = age - 1;
  return age;
};
// 转换付费模式至后端需要的
export const convertPaymentModeBE = (val) => {
  if (val != "" && val != undefined)
    switch (val) {
      case "annual":
        return "A";
      case "semiAnnual":
        return "S";
      case "quarterly":
        return "Q";
      case "monthly":
        return "M";
      default:
        return false;
    }
};
// 处理数字 保留小数点后两位解决银行家和浮点小数计算的问题
export function customRound(num, decimalPlaces) {
  const multiplier = Math.pow(10, decimalPlaces);
  const roundedNum = Math.round(num * multiplier) / multiplier;
  return roundedNum;
}
//解析DistrictOptions
const language = i18n.language;
export function analysisDistrictOptions(data) {
  //console.log("language!!!!:", language);
  let result = [];
  result = data.map((v) => {
    return {
      ...v,
      label: language === "en" ? v?.districtNameEng : v?.districtNameChi,
      value: v?.district,
    };
  });
  return result;
}

// 字段替换
export class BeToFe {
  salutation(data) {
    switch (data) {
      case "Mr":
        return i18n.t("insuredPerson.Mr");
      case "Mrs":
        return i18n.t("insuredPerson.Mrs");
      case "Miss":
        return i18n.t("insuredPerson.Miss");
      case "Ms":
        return i18n.t("insuredPerson.Ms");
      default:
        break;
    }
  }
  idType(data) {
    switch (data) {
      case "I":
        return i18n.t("insuredPerson.hkid");
      case "P":
        return i18n.t("insuredPerson.passport");
      default:
        break;
    }
  }
  area(data) {
    switch (data) {
      case "HKG":
        return i18n.t("insuredPerson.HKG");
      // case "HKG2":
      //   return i18n.t("insuredPerson.HKG2");
      case "KLN":
        return i18n.t("insuredPerson.KLN");
      case "NTD":
        return i18n.t("insuredPerson.NTD");
      default:
        break;
    }
  }
  nation(data) {
    switch (data) {
      case "H":
        return i18n.t("insuredPerson.HKG");
      case "DECLINE":
        return i18n.t("insuredPerson.DECLINE");
      case "O":
        return i18n.t("insuredPerson.OTHERS");
      default:
        break;
    }
  }
  relationShip(data) {
    switch (data) {
      case "Self":
        return i18n.t("quote.Self");
      case "Spouse":
        return i18n.t("quote.Spouse");
      case "Parent":
        return i18n.t("quote.Parent");
      case "Grandparent":
        return i18n.t("quote.Grandparent");
      case "Brother or Sister":
        return i18n.t("quote.Brother or Sister");
      case "Spouse's parent":
        return i18n.t("quote.Spouse's parent");
      case "Spouse's grandparent":
        return i18n.t("quote.Spouse's grandparent");
      case "Child":
        return i18n.t("quote.Child");
      case "Spouse's brother or sister":
        return i18n.t("quote.Spouse's brother or sister");
      default:
        break;
    }
  }
}
// 数据解密
export function decryptData(data) {
  const AuthTokenKey = "&s8opGD_";
  const decrypted = CryptoJS.DES.decrypt(
    data,
    CryptoJS.enc.Latin1.parse(AuthTokenKey),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}

//校验-FormInput的val(string)=>2为小数的数字 string
export const formatDecimal2 = (str) => {
  console.log("进入：", str);
  if (!str) {
    return str;
  }
  str = String(str);
  // 去掉非数字
  let result = str.replace(/[^0-9.]/g, "");
  //如果以0开头，去掉0
  if (result.startsWith("0")) {
    result = result.slice(1);
  }
  // 去除连续的多个小数点
  while (result.includes("..")) {
    result = result.replace("..", ".");
  }
  // 如果有小数，保留2位小数
  if (result.includes(".")) {
    let snum = result.split(".")[1];
    if (snum.length > 2) {
      result = result.slice(0, result.indexOf(".") + 3); // +3 是为了保留两位小数并添加结束的0
    } else if (snum.length === 1) {
      result = result + "0";
    }
  }
  if (!result.includes(".")) {
    // 如果没小数，保留2位.00
    result = result + ".00";
  }

  return result;
};

export function displayBarFn() {
  let urlist = window.location.href.split("/");
  let page = urlist[urlist.length - 1];
  if (["personal-data", "confirm", "health-check"].indexOf(page) > -1) {
    return true;
  } else {
    return false;
  }
}
// 把DD/MM/YYYY转换成2023-06-20格式，然后再转成日期格式,因为moment()是不接受'01/12/1993'格式的
export function formatDateDDMMYYYY(dateStr) {
  let dateArr = dateStr.split("/");
  let newDateStr = `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;
  let momentDate = moment(newDateStr).format("DD/MM/YYYY");
  // console.log('formatDateDDMMYYYY:',dateStr,momentDate);
  return momentDate;
}
// 把1997-01-26T00:00:00转换成DD/MM/YYYY格式
export function formatDateSimple(dateStr) {
  let momentDate = moment(dateStr).format("DD/MM/YYYY");
  // console.log('formatDateDDMMYYYY:',dateStr,momentDate);
  return momentDate;
}

//"1999-01-01T00:00:00.000"; // ISO日期格式 返回多少岁
export function calculateBirthDate(birthDate) {
  const today = new Date();
  const birthDateObj = new Date(birthDate);
  let age = today.getFullYear() - birthDateObj.getFullYear();
  const m = today.getMonth() - birthDateObj.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDateObj.getDate())) {
    age--;
  }
  return age;
}

//ISO 日期转换 DD/MM/YYYY
export function convertISODate(isoDate) {
  const dateObj = new Date(isoDate);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // 注意，月份是从0开始的，所以需要+1
  const year = dateObj.getFullYear();
  return `${day}/${month}/${year}`; // 输出：01/01/1999
}

const placeholder = {
  zh1: "投保人姓名 (請以英文填寫)", //請輸入投保人英文姓名 只有这个，没校验不正确，长度拦截了
  zh2: "投保人姓名 (請以中文填寫 (可選填))", //投保人中文姓名不正確，請用中文重新輸入 只有这个
  zh3: "姓名 (請以英文填寫)", //請輸入受保人姓名
  zh4: "姓名 (請以中文填寫 (可選填))", //受保人姓名不正確，請用中文重新輸入
  //投保人受保人共用
  en1: "Name (Please fill in English)", //--Please input name of Applicant (English)
  en2: "Name (Please fill in Chinese (Optional))", //Invalid name of Applicant, please input again in Chinese
  en3: "Name (Please fill in English)投保人受保人共用名称", // Please input name of Insured Person
  en4: "Name (Please fill in Chinese (Optional))投保人受保人共用名称", //Invalid name of Insured Person, please input again in Chinese
};
//errorMsg 汇总
export const errorMsgEn = {
  LYS_001: {
    salutation: "Please select title",
    applicantNameEn: "Please input name of Applicant (English)",
    // applicantNameChi: "",//非必填
    idType: "Please input either HKID or Passport No. ",
    placeOrigin: "Please select Place of Origin",
    hkid: "Please input HKID",
    passport: "Please input either HKID or Passport No.",
    contactNo: "Please input contact telephone number",
    email: "Please input email address",
    dob: "Please input Date of Birth",
    relationship: "Please select Relationship with Applicant",
    maidNationality: "Please select Document Nationality/Region",
    occupation: "Please select Occupaton",
    insuredType: "Please select the Identity",
    building: "Please input Correspondence Address in Hong Kong ",
    estate: "Please input Correspondence Address in Hong Kong ",
    streetNo: "Please input Correspondence Address in Hong Kong ",
    streetLot: "Please input Correspondence Address in Hong Kong ",
    area: "Please input Correspondence Address in Hong Kong ",
    district: "Please input Correspondence Address in Hong Kong ",
    bankName: "Please select  Bank Name",
    bankNameOthers: "Please input the Bank Name",
    bankAccountNo: "Please input the Bank Account No.",
    bankAccountHolder: "Please input the Bank Account Holder",
  },
  LYS_002: {
    contactNo: "Invalid Contact Telephone No., please input at least 8 digits",
    bankAccountNo: "Input is out of the maximum length, please input again",
    wordLen: "Input is out of the maximum length, please input again.",
  },
  LYS_003: {
    applicantNameEn: "Invalid name of Applicant, please input again in English", //旧系统不存在
    applicantNameChi:
      "Invalid name of Applicant, please input again in Chinese",
    applicantNameEn2:
      "Invalid  name of Insured Person, please input again in English", //旧系统不存在
    applicantNameChi2:
      "Invalid name of Insured Person, please input again in Chinese",
    hkid: "Invalid HKID number please input again",
    email: "Invalid email address, please input again",
    bankAccountNo: "Invalid Bank Account No., please input digits only",
    bankNameOthers: "Invalid Bank Name, please input again.",
  },
  LYS_004: {
    systemerror: "systemerror",
  },
  LYS_005: {
    hkid: "No duplicate HKID is allowed",
    passport: "No duplicate Passport No. is allowed",
  },
  LYS_006: {
    applicantNameEn: "The total length of the name cannot exceed 29",
    applicantNameChi: "The total length of the name cannot exceed 29",
  },
  Home: {
    address: "Please input Insured Premises Address in Hong Kong",
  },
};
export const errorMsgCh = {
  LYS_001: {
    salutation: "請選擇稱謂",
    applicantNameEn: "請輸入投保人英文姓名",
    // applicantNameChi: "",//非必填
    idType: "請輸入身份證或護照號碼",
    placeOrigin: "請選擇起保地點",
    hkid: "請輸入身份證",
    passport: "請輸入身份證或護照號碼",
    contactNo: "請輸入聯絡電話號碼",
    email: "請輸入電郵地址",
    dob: "請輸入出生日期",
    relationship: "請選擇與投保人關係",
    maidNationality: "請選擇證件國籍或所屬地區",
    occupation: "請選擇職業",
    insuredType: "請選擇身份",
    building: "請輸入香港通訊地址",
    estate: "請輸入香港通訊地址",
    streetNo: "請輸入香港通訊地址",
    streetLot: "請輸入香港通訊地址",
    area: "請輸入香港通訊地址",
    district: "請輸入香港通訊地址",
    bankName: "請選擇銀行",
    bankNameOthers: "請輸入銀行名稱",
    bankAccountNo: "請輸入銀行戶口號碼",
    bankAccountHolder: "請輸入銀行戶口持有人姓名",
  },
  LYS_002: {
    contactNo: "聯絡電話號碼錯誤，請輸入最少8個數字",
    bankAccountNo: "輸入文字過長，請重新輸入。",
    wordLen: "輸入文字過長，請重新輸入。",
  },
  LYS_003: {
    applicantNameEn: "投保人姓氏不正確，請用英文重新輸入",
    applicantNameChi: "投保人中文姓名不正確，請用中文重新輸入",
    applicantNameEn2: "受保人姓氏不正確，請用英文重新輸入",
    applicantNameChi2: "受保人姓名不正確，請用中文重新輸入",
    hkid: "身份證號碼錯誤，請重新輸入",
    email: "電郵地址錯誤，請重新輸入",
    bankAccountNo: "銀行戶口號碼錯誤，請輸入數字",
    bankNameOthers: "銀行名稱不正確，請重新輸入",
  },
  LYS_004: {
    systemerror: "systemerror",
  },
  LYS_005: {
    hkid: "不能有重複的香港身份證號碼",
    passport: "不能有重複的護照號碼",
  },
  LYS_006: {
    applicantNameEn: "姓名总长度不能超过29",
    applicantNameChi: "姓名总长度不能超过29",
  },
  Home: {
    //LYS_001且是tab=home的情况下，就是下面的
    address: "請輸入香港投保住宅地址",
  },
};
// 滚动方法
export const scrollFun = (containerDom, dom, time) => {
  clearTimeout(wait);
  LoadBar.show();
  var wait = setTimeout(
    () => {
      //容器元素
      const container = document.getElementById(containerDom);
      const formError = container.querySelector(".aia-bx-form-error");
      // const errorElement = container.querySelector(
      //   dom ? dom : ".aia-bx-form-error"
      // );
      const errorElement =
        formError === null
          ? container.querySelector(".aia-bx-quote-tab-error")
          : formError;
      // console.log("第一个有errorElement的元素:", errorElement);
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "end",
        });
        // setScrollIsNot(true);
      }
      LoadBar.hide();
    },
    time ? time : 1000
  );
};

/**
 * @desc 判断是否是对象，并且对象非空
 * @param {*} obj 入参为对象
 * @returns Boolean
 */
export const isNonEmptyObj = (obj) => {
  return obj !== null && typeof obj === "object" && Object.keys(obj).length > 0;
};
// dental 删除重复项跳转顺序 标准在后
export const getRightOrderDental = (getDentalList) => {
  const standardPlanObjects = getDentalList.filter(
    (obj) => obj.dentalPlan === "B"
  );
  const otherObjects = getDentalList.filter((obj) => obj.dentalPlan !== "B");

  return [...otherObjects, ...standardPlanObjects];
};

/**
 * @description 从sessionStorage中获取并尝试解析JSON数据
 * @demo 
  使用这个函数
  const insuredPersonInfoKey = "insuredPersonInfo";
  const personInfo = getSessionStorageJson(insuredPersonInfoKey);
  if (personInfo) {
     console.log(personInfo);
  } else {
     console.log('Failed to retrieve or parse insured person info');
  } 
 * @param {string} key - sessionStorage中的键名
 * @returns {Object|null|undefined} - 解析成功的JSON对象，如果为空或解析失败则返回null或undefined
 */
export const getSessionStorageJson = (key) => {
  const storageItem = sessionStorage.getItem(key);
  if (!storageItem) {
    console.log(`No data found for "${key}" in sessionStorage`);
    return null; // 或者根据您的需求返回undefined
  }
  try {
    const parsedData = JSON.parse(storageItem);
    return parsedData;
  } catch (error) {
    console.error(`Failed to parse "${key}" from sessionStorage:`, error);
    return null; // 或者抛出错误，取决于您希望如何处理解析失败的情况
  }
};

/**
 *
 * @param {*} filename 文件名
 * @returns 文件类型
 */
export const getFileExtension = (filename) => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) return ""; // 如果没有找到"."，则返回空字符串
  return filename.substring(lastDotIndex + 1);
};

// 数字加千分位
export function formatNumber(num) {
  if (typeof num !== "number") {
    return 0;
  }
  return num.toLocaleString("en-US");
}

export function detection(url) {
  // 判断是安卓还是ios ipad
  let userMessage = navigator.userAgent.toLowerCase();
  if (/android|adr/gi.test(userMessage)) {
    // 当前为Andriod环境
    window.open(url);
  } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(userMessage)) {
    // 当前为iphone环境
    window.open(url);
  } else if (/iPad/gi.test(userMessage)) {
    window.open(url);
  } else {
    window.open(url);
  }
}

export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};
export const isIOSAPP = () => {
  //@ts-ignore window 上不存在IOSMobileApp 但是iOS有 由andy yang 提供
  return window.IOSMobileApp;
};

/**
 * 判断是否为移动端APP
 */
export const isMobileAPP = () => {
  let isMobile = false;
  isMobile =
    // @ts-ignore window 上不存在IOSMobileApp 但是iOS有 由andy yang 提供
    window.IOSMobileApp ||
    // @ts-ignore window 上不存在IOSMobileApp 但是iOS有 由andy yang 提供
    window.parent.IOSMobileApp ||
    (isAndroid() &&
      //@ts-ignore  Android Mobile APP 内置对象 不用申明, 由andy yang 提供
      (typeof AndroidShareHandler !== 'undefined' ||
        //@ts-ignore  Android Mobile APP 内置对象 不用申明, 由andy yang 提供
        typeof Android !== 'undefined'));
  return isMobile;
};

/**
 * 判断是否为移动端APP并且隐藏头部导航栏的页面
 */
export const isMobileAPPHiddenHeader = () => {
  let isHidden = false;
  // BX主站特定頁面才生效，其他站点可以根据需求判定是否删除代码
  // const hideHeaderPath = findMatchingItem(window.location.href, hideList);

  // 如果是其他独立网站，所有页面都需要hidden header,直接设定默认值
  const hideHeaderPath = { path: 'home', type: 'mobileImageNavBar', color: '' };
  // 特定隐藏url 且当前是Mobile App 就标记隐藏
  if (isEmpty(hideHeaderPath) !== true && isMobileAPP() === true) {
    isHidden = true;
  } else {
    isHidden = false;
  }
  if (isHidden) {
    mobileAPPHiddenHeaderCallWebkit(
      hideHeaderPath?.type,
      window.document.title,
      hideHeaderPath?.color
    );
  }

  return isHidden;
};

/**
 * 为嵌入mobile App单独的处理：通过webkit发送消息,通知mobile App 隐藏header
 * @param type
 */
export const mobileAPPHiddenHeaderCallWebkit = (
  type = 'mobileImageNavBar',
  title,
  color) => {
  const param = { header: { style: type, title: title, color: color } };
  const webkit = window.webkit;
  if (webkit && webkit.messageHandlers) {
    console.log('向IOS Mobile APP 推送数据', JSON.stringify(param));
    // IOS MobileAPP 推送数据
    webkit.messageHandlers.bcMobileHandler.postMessage(param);
  } else if (
    isAndroid() &&
    // @ts-ignore: Android Mobile App 内置对象
    typeof Android !== 'undefined' &&
    // @ts-ignore: Android Mobile App 内置方法
    // eslint-disable-next-line no-undef
    typeof Android.bcMobileHandler !== 'undefined'
  ) {
    console.log('向Android Mobile APP 推送数据', JSON.stringify(param));

    // @ts-ignore: 如果内置方法和内置对象都存在,就向 Android Mobile App 推送数据
    // eslint-disable-next-line no-undef
    Android.bcMobileHandler(JSON.stringify(param));
  } else if (
    isAndroid() &&
    // @ts-ignore: Android Mobile App 内置对象
    typeof AndroidShareHandler !== 'undefined' &&
    // @ts-ignore: Android Mobile App 内置方法
    // eslint-disable-next-line no-undef
    typeof AndroidShareHandler.bcMobileHandler !== 'undefined'
  ) {
    console.log(
      '向AndroidShareHandler Mobile APP 推送数据',
      JSON.stringify(param)
    );
    // @ts-ignore: 如果内置方法和内置对象都存在,就向 Android Mobile App 推送数据
    // eslint-disable-next-line no-undef
    AndroidShareHandler.bcMobileHandler(JSON.stringify(param));
  } else {
    console.log('%c当前浏览器不支持推送数据到MobileApp', 'color:orange');
  }
};
